import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-ai',
  templateUrl: './about-us-ai.component.html',
  styleUrls: ['./about-us-ai.component.scss']
})
export class AboutUsAiComponent implements OnInit {

  data = [
    {
      img: 'assets/img/culture.png',
      header: 'Cutting-edge neuroscience',
      description: 'Anima is built on the latest discoveries in cognitive and affective neuroscience. We don’t rely on vague questionnaires or self-reports — we decode the patterns of your attention to uncover what\'s really happening in your mind. Every insight is grounded in peer-reviewed science and tested in high-stress environments.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Eye-tracking technology',
      description: 'Your eyes reveal more than words ever can. Anima uses your webcam to track subtle shifts in gaze and focus — all within a browser, with no special hardware needed. This technology helps us capture your mental state in real-time, offering a more accurate and dynamic picture than traditional assessments.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Total privacy',
      description: 'Your mental data is yours alone. Anima is designed with strict privacy-first architecture: no raw video is captured, and all processing is secured and anonymized. We follow rigorous global standards to protect your information, so you can explore your inner world without worry.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Insightful AI companion',
      description: 'Anima isn’t just a tool — it’s your AI companion, trained to recognize patterns in your attention and offer meaningful reflections without bias or judgment. It helps you understand your mental state in real time, guiding you with clarity and care — like someone who truly gets what’s going on beneath the surface.',
      num: '04'
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
